'use strict'

import React from 'react'

import {
  currencySymbol,
  numberWithCommas,
  secondaryCurrencyCost
} from '../shared'

const Costs = ({ cost, annualCost, rates, fromCurrency, toCurrency }) => {
  const parseCosts = () => {
    const secondaryCost = secondaryCurrencyCost(
      cost,
      rates,
      fromCurrency,
      toCurrency
    )
    const secondaryAnnualCost = secondaryCurrencyCost(
      annualCost,
      rates,
      fromCurrency,
      toCurrency
    )
    const costWithCommas = numberWithCommas(cost)
    const annualCostWithCommas = numberWithCommas(annualCost)
    const secondaryCostWithCommas = numberWithCommas(secondaryCost)
    const secondaryAnnualCostWithCommas = numberWithCommas(secondaryAnnualCost)
    return {
      costWithCommas,
      annualCostWithCommas,
      secondaryCostWithCommas,
      secondaryAnnualCostWithCommas
    }
  }

  const {
    costWithCommas,
    annualCostWithCommas,
    secondaryCostWithCommas,
    secondaryAnnualCostWithCommas
  } = parseCosts()

  return (
    <div className='flex flex-col mx-auto items-center mt-4 md:mt-8'>
      <div className='p-4'>
        <p className='text-xl md:text-3xl text-center'>meeting cost</p>
        <h2 className='text-2xl md:text-4xl text-center'>
          {currencySymbol(fromCurrency)}
          {costWithCommas}&nbsp;
          <span className='block md:inline-block text-blue-400 text-xl md:text-3xl'>
            ({currencySymbol(toCurrency)}
            {secondaryCostWithCommas})
          </span>
        </h2>
      </div>
      <div className='p-4'>
        <p className='text-xl md:text-3xl text-center'>anual cost</p>
        <h2 className='text-2xl md:text-4xl text-center'>
          {currencySymbol(fromCurrency)}
          {annualCostWithCommas}&nbsp;
          <span className='block md:inline-block text-blue-400 text-xl md:text-3xl'>
            ({currencySymbol(toCurrency)}
            {secondaryAnnualCostWithCommas})
          </span>
        </h2>
      </div>
    </div>
  )
}

export default Costs
